/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Runs_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "Start one to see it here." |
*
* @param {Agent_Runs_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_runs_empty_description = /** @type {((inputs?: Agent_Runs_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Runs_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Starten Sie einen Lauf, um ihn hier zu sehen.")
	return /** @type {LocalizedString} */ ("Start one to see it here.")
});